module.exports = __webpack_public_path__ + "images/application/bg-stripes-light-db3e55fb.png";